/*
  QRScanner AppState Beahviours:
    - initializing: Not shown. Camera needs to be present but invisible to trigger the camera permission request.
    - tutorial: Not shown.
      - The camera should be "active", but invisible. While in this phase, hte camera should be trying 
        to capture the serial code only.
    - playing: The camera should be made visible, and QR Codes scanning should be enabled.
    - validating: The camera should be stopped and invisible.
    - redirecting: The camera should be stopped and invisible.
*/

import "./QRScanner.css";
import {useEffect,useMemo, useRef, useCallback} from "react";
import { useZxing } from "react-zxing";
// import { type AppState } from "@/types/SharedTypes";
import { BarcodeFormat, DecodeHintType } from "@zxing/library";
import { useAppState } from "@/contexts/AppStateContext";

// export type ScannerStatusType = 'stopped' | 'playing' | 'initializing';
interface QRScannerProps {
  onCodeDetected: (code: string) => void;
  onCapture: (imageData: string) => void;
  onPlaying: () => void;
}

export const QRScanner = ({ onCodeDetected, onCapture, onPlaying }: QRScannerProps) => {
  const {appState} = useAppState();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const hints = useMemo(() => new Map<DecodeHintType, any>([
    //[DecodeHintType.TRY_HARDER, true],
    [DecodeHintType.POSSIBLE_FORMATS, [BarcodeFormat.QR_CODE]],
  ]), []);
const { ref } = useZxing({
  onDecodeResult(result) {
    onCodeDetected(result.getText());
    // const points = result.getResultPoints();
    // captureImage(points); 
  },
  hints
});
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const innerStatus = ['instructions','waitingforuid', 'playing', 'validating'].includes(appState) ? 'playing' : 'stopped';
  const frameStatus = ['instructions','waitingforuid', 'playing', 'validating','done'].includes(appState) ? 'playing' : 'stopped';

  useEffect(() => {
    const srcObject = ref.current?.srcObject;
    if (srcObject instanceof MediaStream) {
        const videoTrack = srcObject.getVideoTracks()[0];
        if (videoTrack && innerStatus === 'playing') {
            videoTrack.applyConstraints({
                advanced: [{ zoom: 2 } as MediaTrackConstraintSet] // Type assertion
            }).catch((error) => {
                console.error("Failed to apply zoom constraint:", error);
            });
        }
    }
  }, [ref, innerStatus]);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const captureImage = useCallback(() => {
  if (!ref.current || !canvasRef.current) return;

  const video = ref.current;
  const canvas = canvasRef.current;
  const ctx = canvas.getContext("2d");
  if (!ctx) return;

  canvas.width = video.videoWidth;
  canvas.height = video.videoHeight;

  ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

  const imageData = canvas.toDataURL("image/jpeg");
  onCapture(imageData);
}, [ref, onCapture]);


// Image capture interval removed - only QR code detection is needed now (serial code capture removed)
// useEffect(() => {
//   if (innerStatus !== "playing") return;
//
//   const interval = setInterval(() => {
//     captureImage();
//   }, 800);
//
//   return () => clearInterval(interval);
// }, [innerStatus, captureImage]);




  return (
    <>
      <canvas ref={canvasRef} width={180} height={180} style={{ display: 'none' }} />
      <video
        ref={ref}
        preload="none"
        className={`video portrait-mode ${innerStatus}`}
        onPlaying={() => onPlaying()}
        width={180}
        height={180}
      />
      <div className={`frame ${frameStatus === 'playing' ? "playing" : "stopped"}`}></div>
      {/* <div className={`overlay ${innerStatus === 'playing' ? "playing" : "stopped"}`}></div> */}

      <div id="inner-circle"></div>
        </>
      );
}


// Uncomment and use the following code if you want to display the cropped image after capturing it.

// import { useState } from "react";
// const [croppedImage, setCroppedImage] = useState<string | null>(null);

  // setCroppedImage(imageData); // place this in the captureImage function where you call onCapture


  // place this in the return statement to display the cropped image
      {/* {croppedImage && (
        <img src={croppedImage} alt="Cropped QR Code" className="cropped-image" height={"auto"} width={"auto"} />
      )} */}